"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Record = void 0;
class Record {
    /**
     * Create a `Record` instance from an `IRecord` object.
     *
     * @deprecated This constructor is not intended for public use.
     */
    constructor(record, options) {
        this.record = record;
        const { voTransformOptions } = options;
        this.voTransformOptions = voTransformOptions;
    }
    get id() {
        return this.record.id;
    }
    /**
     * The comment list of the record. If no comments exist, an empty array is returned.
     */
    get comments() {
        var _a;
        return (_a = this.record.comments) !== null && _a !== void 0 ? _a : [];
    }
    /**
     * Get the view object of the record via `transform`.
     */
    getViewObject(transform) {
        return transform(this.record, this.voTransformOptions);
    }
}
exports.Record = Record;
//# sourceMappingURL=record.js.map